import BaseEndPoint from "../BaseEndPoint";

export default class ClientPractitioner extends BaseEndPoint {
    constructor(client) {
        super(client);

        this.getUrlPath = this.getUrlPath.bind(this);
    }

    getUrlPath(path) {
        return super.getUrlPath("/client-practitioner/" + path);
    }

    /**
     * Retrieves the authenticated practitioner-portal user's assigned clientId and all accessible
     * client addresses ({ clientId, clientAddresses[] }). Returns 403 for non-practitioner users.
     *
     * @return {Promise<Response>}
     */
    getAddresses() {
        const settings = {
            ...this._getDefaultFetchSettings(),
            method: "GET"
        };

        return this._send(this.getUrlPath("addresses"), settings);
    }

    /**
     * Retrieves all staff across the authenticated practitioner-portal user's accessible sites.
     *
     * @return {Promise<Response>}
     */
    getStaff() {
        const settings = {
            ...this._getDefaultFetchSettings(),
            method: "GET"
        };

        return this._send(this.getUrlPath("staff"), settings);
    }
}
